var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useCheckShowBalance } from 'common/hooks/use-check-show-thanks-balance';
import { Modal } from 'ui-kit/modal';
import { Button } from 'ui-kit/button';
import { Typography } from 'ui-kit/typography';
import { RoleType, WalletType } from 'common/types/server-api-dtos';
import { Box } from 'ui-kit/box';
import { Divider } from 'ui-kit/divider';
import { InfoBlock } from 'ui-kit/info-block';
import { CurrencyIcon } from '../currency-icon';
import { SupervisorCurrencyIcon } from '../supervisor-currency-icon';
import { ThanksCurrencyIcon } from '../thanks-currency-icon';
import { useBreakpoints } from 'common/hooks/use-breakpoints';
import { userService } from 'common/utils/user-service';
import styles from './wallet-instruction-modal.module.scss';
export var WalletInstructionModal = function (_a) {
    var isOpen = _a.isOpen, closeModal = _a.closeModal;
    var t = useTranslation().t;
    var isManager = userService.hasRole(RoleType.Manager);
    var isSupervisor = userService.hasRole(RoleType.Supervisor);
    var showBalanceThank = useCheckShowBalance(WalletType.Thank);
    var showBalanceSupervisor = useCheckShowBalance(WalletType.SupervisorBalance);
    var userType = isManager ? 'manager' : isSupervisor ? 'supervisor' : 'user';
    var isDesktopXL = useBreakpoints('desktop-xl').isDesktopXL;
    var walletTypeArr = [
        {
            icon: _jsx(ThanksCurrencyIcon, { width: isDesktopXL ? 1.25 : 1 }),
            title: t("common.walletInstructionsModal.wallet.thanks"),
            description: t("common.walletInstructionsModal.wallet.description.".concat(userType, ".thanks")),
            visible: showBalanceThank || isManager,
        },
        {
            icon: _jsx(SupervisorCurrencyIcon, { width: isDesktopXL ? 1.25 : 1 }),
            title: t("common.walletInstructionsModal.wallet.supervisor"),
            description: t("common.walletInstructionsModal.wallet.description.".concat(userType, ".supervisor")),
            visible: (showBalanceSupervisor && userType !== 'user') || isManager,
        },
        {
            icon: _jsx(CurrencyIcon, { width: isDesktopXL ? 1.25 : 1 }),
            title: t("common.walletInstructionsModal.wallet.currency"),
            description: t("common.walletInstructionsModal.wallet.description.".concat(userType, ".currency")),
            visible: true,
        },
    ].filter(function (el) { return el.visible; });
    return (_jsxs(Modal, __assign({ isOpen: isOpen, title: t('common.walletInstructionsModal.title'), onClose: closeModal }, { children: [_jsx(Typography, { children: t("common.walletInstructionsModal.subTitle.".concat(userType)) }), _jsx(Divider, { my: 8 }), _jsxs(Box, __assign({ display: "flex", direction: "column", gap: 8 }, { children: [walletTypeArr.map(function (_a) {
                        var description = _a.description, icon = _a.icon, title = _a.title;
                        return (_jsxs(Box, __assign({ display: "flex", alignItems: "flex-start", wrap: "wrap", gap: 2, gapXl: 6 }, { children: [_jsxs(Box, __assign({ className: styles.leftColumn, display: "flex", alignItems: "center", gap: 4 }, { children: [_jsx(Box, __assign({ className: styles.iconWrapper }, { children: icon })), _jsx(Typography, __assign({ className: styles.title, color: "primary", variant: "body-s", weight: "semi-bold" }, { children: title }))] })), _jsx(Box, __assign({ className: styles.rightColumn }, { children: _jsx(Typography, __assign({ color: "primary", variant: "body-s" }, { children: description })) }))] }), title));
                    }), isManager && _jsx(InfoBlock, { text: t('common.walletInstructionsModal.managerNotification') })] })), _jsx(Modal.Footer, __assign({ className: styles.footer }, { children: _jsx(Button, __assign({ onClickSimple: closeModal }, { children: t('common.walletInstructionsModal.successButton') })) }))] })));
};
